import React from "react";
import { Helmet } from 'react-helmet';
import Nav from "../components/nav/Nav";
import HeroSection from "../components/hero_section/HeroSection";
import CardSection from "../components/card/CardSection";
import CTASection from "../components/cta/CTA";
import Footer from "../components/footer/Footer";
function HomePage() {
    const featCardData = [
        {
          title: "Essential Terms",
          description: "Master the key vocabulary that makes Xiaohongshu unique",
        },
        {
          title: "User Guide",
          description: "Learn how to navigate and engage with the community effectively",
        },
        {
          title: "Content Creation",
          description: "Understand the terminology needed to create and share content",
        },
      ];

    const dictCardData = [
        {
            "title": "笔记 (bǐjì)",
            "description": "Posts on Xiaohongshu, similar to TikTok videos or Instagram posts. The basic unit of content sharing."
        },
        {
            "title": "种草 (zhǒngcǎo)",
            "description": "Literally \"planting grass\" - when content makes you want to buy something. Similar to \"adding to wishlist\" or \"influenced to buy.\""
        },
        {
            "title": "拔草 (bácǎo)",
            "description": "Literally \"pulling grass\" - when you lose interest in buying something, often after disappointing reviews or experiences."
        }
    ];
    const interactionCardData = [
        {
            "title": "点赞 (diǎnzàn)",
            "description": "The \"like\" button - show appreciation for content."
        },
        {
            "title": "转发 (zhuǎnfā)",
            "description": "Share or repost content to your followers, similar to retweet."
        },
        {
            "title": "私信 (sīxìn)",
            "description": "Direct messages between users, similar to DMs on other platforms."
        }
    ]
    const handleButtonClick = () => {
        console.log("Button clicked, handle the action here.");
      };

    const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "XiaoHongShu Lingo",
    "alternateName": ["XHS Lingo", "XHSLingo", "Rednote Lingo"],
    "url": "https://xhslingo.com"
    };

    return (
      <div >
        <Helmet>
            <meta charSet="UTF-8"/>
            <meta name="google-adsense-account" content="ca-pub-5419912423604609"></meta>
            <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
            <meta name="description" content="XiaoHongShu Lingo is your essential guide to understanding Xiaohongshu (小红书/Rednote) terminology. Learn key terms used in fashion, beauty, content creation, and more."/>
            <meta name="keywords" content="Xiaohongshu, RedNote App, XiaoHongShu Lingo, Social Media Terms, Fashion, Beauty, TikTok, Hashtags, Content Creation, Chinese Social Media, Influencers, KOL"/>
            <meta name="author" content="XiaoHongShu Lingo Team"/>
            <meta property="og:site_name" content="XiaoHongShu Lingo" />
            <meta property="og:title" content="XiaoHongShu Lingo - Your Guide to Xiaohongshu Language"/>
            <meta property="og:description" content="Your essential guide to understanding Xiaohongshu (Rednote) terminology and community engagement. Explore content creation tips, fashion, beauty, and more!"/>
            <meta property="og:image" content="https://xhslingo.com/logo512.png"/>
            <meta property="og:url" content="https://xhslingo.com"/>
            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:title" content="XiaoHongShu Lingo - Your Guide to Xiaohongshu Language"/>
            <meta name="twitter:description" content="Master the key terminology and trends on Xiaohongshu (小红书/Rednote), the Chinese social media platform. Learn about content creation, beauty, fashion, and more."/>
            <meta name="twitter:image" content="https://xhslingo.com/logo512.png"/>
            <meta name="robots" content="index, follow"/>
            <title>XiaoHongShu Lingo - Your Guide to Xiaohongshu (Rednote) Language</title>
            <script type="application/ld+json">
                {JSON.stringify(structuredData)}
            </script>
            <link rel="canonical" href="https://xhslingo.com"/>
            <link href="https://cdnjs.cloudflare.com/ajax/libs/tailwindcss/2.2.19/tailwind.min.css" rel="stylesheet"/>     
        </Helmet>

        <Nav />
        <HeroSection
            title="Welcome to XHS Lingo"
            subtitle="Your essential guide to understanding Xiaohongshu (小红书/REDnote) terminology"
            description="Made for TikTok refugees navigating the Chinese social media landscape"
            buttonText="Start Learning"
            buttonLink="/rednote-hashtag-finder"
            backgroundColor="bg-red-500"  // 可选传递其他颜色
            textColor="text-white"          // 可选传递其他文字颜色
        />
        <section className="py-16">
            <CardSection cards={featCardData} />  {/* 将卡片数据传递给组件 */}
        </section>

        <section className="bg-white py-16">
            <h2 className="text-3xl font-bold mb-8 text-center">Essential XiaoHongShu Terms</h2>
            <CardSection cards={dictCardData} />  {/* 将卡片数据传递给组件 */}
        </section>

        <section className="bg-white py-16">
            <h2 className="text-3xl font-bold mb-8 text-center">Interaction Features</h2>
            <CardSection cards={interactionCardData} />  {/* 将卡片数据传递给组件 */}
        </section>
        <CTASection
            title="Ready to Master XHS Lingo?"
            description="Join our community and make your Xiaohongshu (REDnote) experience smoother!"
            buttonText="Get Early Access"
            onButtonClick={handleButtonClick}
        />
        <Footer />
    </div>
    );
  }
  
export default HomePage;